import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ICampaign } from '../../../../shared/models/campaign.model';
import { CampaignService, UtilService, EventsService, VariablesService } from '../../../../shared/services';
import { ISystemEvent, IGTM } from '../../../../shared/models/events.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss']
})
export class RewardsComponent implements OnInit {

  rewardForm: FormGroup;
  amountD: FormControl;
  amountR: FormControl;
  title: FormControl;
  desc: FormControl;
  rewardsCount: FormControl;
  deliveryDate: FormControl;
  isUnlimited: FormControl;
  @Input() info;

  rewards;
  rewardId = {
    id: undefined,
    index: undefined
  };

  @Input() draft: ICampaign;
  @ViewChild('addRewardModal', { static: true }) rewardDialog: TemplateRef<any>;
  @ViewChild('deleteRewardModal', { static: true }) deleteRewardDialog: TemplateRef<any>;
  months = [
    { name: 'January', pos: 1 },
    { name: 'February', pos: 2 },
    { name: 'March', pos: 3 },
    { name: 'April', pos: 4 },
    { name: 'May', pos: 5 },
    { name: 'June', pos: 6 },
    { name: 'July', pos: 7 },
    { name: 'August', pos: 8 },
    { name: 'September', pos: 9 },
    { name: 'October', pos: 10 },
    { name: 'November', pos: 11 },
    { name: 'December', pos: 12 },
  ];

  constructor(
    private dialog: MatDialog,
    private campaignService: CampaignService,
    private util: UtilService,
    private vars: VariablesService,
    private events: EventsService,
    private router: Router,
    @Inject(DOCUMENT) private document: any
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.initForm();
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      this.rewards = this.draft.rewards;
    });
  }
  /**
   * Init the form
   */
  initForm() {
    this.rewardForm = new FormGroup({
      amountR: this.amountR = new FormControl('', [Validators.required, Validators.min(100)]),
      amountD: this.amountD = new FormControl('', [Validators.required, Validators.min(15)]),
      title: this.title = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      desc: this.desc = new FormControl('', [Validators.required, Validators.minLength(15)]),
      rewardsCount: this.rewardsCount = new FormControl('', Validators.required),
      isUnlimited: this.isUnlimited = new FormControl('', []),
      deliveryDate: this.deliveryDate = new FormControl('', Validators.required),
    });
  }
  /**Validation message function */
  getErrorMessage(control: FormControl) {
    const name = control.toString();
    switch (true) {
      case control.hasError('required'):
        return 'This field is required';
      case control.hasError('minlength'):
        return 'minimum 15 characters required';
    }
  }
  /**External url */
  goExternal(url) {
    this.document.location.href = url;
  }
  /**Submit the entire rwards screen */
  submitButton() {
    this.publishCampaign();
  }

  /**Open dialog/modal */
  openDialog(dialog, id?: any, index?: any): void {
    if (id) {
      this.rewardId.id = id;
      this.rewardId.index = index;
    }
    const dialogRef = this.dialog.open(dialog, {
      // width: '96vw',
      maxWidth: '96vw',
      panelClass: 'round-dialog'
    });
    dialogRef.afterClosed().subscribe(result => result);
  }
  /**close dialog */
  closeDialog() {
    this.dialog.closeAll();
    this.rewardForm.reset();
  }
  /**Toggle count  */
  toggleCount() {
    this.rewardsCount.enabled ? this.rewardsCount.disable() : this.rewardsCount.enable();
  }
  /**on rupee input */
  onInput() {
    let value: number = this.amountR.value / 70;
    value = Math.ceil(value);
    value < 15 ? this.amountD.setValue(15) : this.amountD.setValue(value);
  }
  /**format date */
  getFormatedDate() {
    const date: Date = this.deliveryDate.value;
    let temp: string;
    for (const item of this.months) {
      if (date.getUTCMonth() === item.pos) {
        temp = item.name + ' ' + date.getUTCFullYear().toString();
        return temp;
      }
    }
  }
  /**Save rewards button*/
  save() {
    this.document.getElementById('rewardFormId').click();
  }
  /**Submit add rewards form */
  submit() {
    if (this.rewardForm.valid) {
      const payload = {
        'amount_to': this.amountR.value,
        'amount_usd': this.amountD.value,
        'descp': this.title.value,
        'notes': this.desc.value,
        'expected_date': this.getFormatedDate(),
      };
      this.rewardsCount.enabled ? payload['backers'] = this.rewardsCount.value : payload['rewardCountUnlimited'] = 'on';
      this.addReward(payload, this.draft.id);
    } else {
      this.util.checkValidForm(this.rewardForm);
    }
  }
  /**
   * Delet reward
   */
  delete() {
    this.deleteReward(this.rewardId.id);
  }
  /**Add rewards api call */
  addReward(payload, id) {
    this.campaignService.addReward(payload, id).subscribe((res: any) => {
      this.dialog.closeAll();
      this.rewardForm.reset();
      this.draft.rewards.push(res.data);
      this.vars.draftObs.next(this.draft);
      this.rewardForm.reset();
    });
  }
  /**Delete reward */
  deleteReward(rewardId) {
    this.campaignService.deletReward(this.draft.id, rewardId).subscribe((res: any) => {
      this.draft.rewards.splice(this.rewardId.index, 1);
      this.vars.draftObs.next(this.draft);
      this.dialog.closeAll();
    });
  }
  publishCampaign() {
    const payload = {
      'status_flag': 3
    };
    this.campaignService.publishCampaign(payload, this.draft.id).subscribe((res: any) => {
      this.gtmPush();
      this.sendSystemEvent();
      // this.goExternal(`/campaign/thank_you.php?fmd_campaign_id=${this.draft.id}`);
      this.router.navigate([`/new/campaign_created`], {
        queryParams: { campaign_id: this.draft.id, parent_cause_id: this.draft.parent_cause_id }
      });
      this.util.openSnackBar('Campaign Successfully created', 'success');
      return res;
    });
  }
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent() {
    const payload: ISystemEvent = {
      eventName: 'start_a_campaign_step5_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step5',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (this.draft?.id) {
      payload.event_type_id = +this.draft?.id;
    }
    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush() {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      eventLabel: 'step5_completed',
      Campaign_cause_id: this.draft.cause_id,
      Campaign_id: this.draft.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draft.parent_cause_id)
    };
    this.events.gtmPush(dataPush);
  }
}
